/**
 * 認証情報ストア (zustand)
 * Basic 認証用の base64 エンコード済み credentials を保持。
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  credentials: string | null;
  username: string | null;
  login: (username: string, password: string) => void;
  logout: () => void;
}

function toBase64(s: string): string {
  // Unicode 対応
  return btoa(unescape(encodeURIComponent(s)));
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      credentials: null,
      username: null,
      login: (username, password) => {
        const credentials = toBase64(`${username}:${password}`);
        set({ credentials, username });
      },
      logout: () => set({ credentials: null, username: null }),
    }),
    { name: "wonect-picking-auth" },
  ),
);
